uic-table-column-checkbox {
    display: none;
}
